export const FETCH_CARE_HEARTH_INSIGHTS = "app/CareHearthInsights/FETCH_LIST";
export const FETCH_CARE_HEARTH_INSIGHTS_SUCCESS =
  "app/CareHearthInsights/FETCH_LIST_SUCCESS";
export const FETCH_CARE_HEARTH_INSIGHTS_FAILURE =
  "app/CareHearthInsights/FETCH_LIST_FAILURE";
export const FETCH_CARE_HEARTH_INSIGHT = "app/CareHearthInsights/FETCH_ONE";
export const FETCH_CARE_HEARTH_INSIGHT_SUCCESS =
  "app/CareHearthInsights/FETCH_ONE_SUCCESS";
export const FETCH_CARE_HEARTH_INSIGHT_FAILURE =
  "app/CareHearthInsights/FETCH_ONE_FAILURE";
